import { MetaDataCursorPage } from './jsonapi';

export enum FinancialStatementType {
  ORDINARY = 'ORDINARY',
  ABBREVIATED = 'ABBREVIATED',
  MICRO = 'MICRO',
}

export interface FinancialStatement {
  id: string;
  description: string | null;
  statementType: FinancialStatementType;
  year: number;
  approvalDate: string | null;
}

export interface FinancialStatementsResponse {
  financialStatements: FinancialStatement[];
  page: MetaDataCursorPage;
}

export const FinancialStatementQueryKeys = {
  all: (companyId: string) => ['FinancialStatements', companyId],
  detail: (companyId: string, statementId: string) => ['FinancialStatements', companyId, statementId],
  list: (companyId: string) => ['FinancialStatements', companyId, 'list'],
};

export enum FinancialStatementSchemaLineType {
  Header = 'HEADER',
  Detail = 'DETAIL',
  Total = 'TOTAL',
}

export const FinancialStatementItemResourceType = 'financial-statement-item';

export interface FinancialStatementItemReference {
  id: string;
  code: string;
  name: string;
}

export interface FinancialStatementSchemaLine {
  id: string;
  name: string | null;
  lineType: FinancialStatementSchemaLineType;
  statementTypes: FinancialStatementType[];
  position: number;
  depth: number;
  isAnalytical: boolean;
  item?: FinancialStatementItemReference;
}

export const FinancialStatementSchemaLineQueryKeys = {
  list: (statementType: FinancialStatementType) => ['FinancialStatementSchemaLines', 'list', statementType],
};
